/**
 * Audit Log Types
 * Type definitions for audit log data
 */

export interface AuditLog {
  id: string;
  actionType: string;
  actionDescription: string;
  requestDetails: string;
  actorId: string | null;
  actorName: string;
  actorRole: string;
  actionDate: string;
  actionStatus: 'Success' | 'Failed';
  errorMessage: string | null;
}

export interface AuditLogFilters {
  actionType?: string;
  actorId?: string;
  startDate?: string;
  endDate?: string;
  actionStatus?: string;
  page?: number;
  pageSize?: number;
}

export interface PagedAuditLogResponse {
  total: number;
  page: number;
  pageSize: number;
  data: AuditLog[];
}

export const ACTION_TYPE_MAP: Record<string, string> = {
  // Administrator Management
  'CreateAdminUserCommand': 'Create Administrator',
  'DeleteAdminUserCommand': 'Delete Administrator',
  'UpdateAdminUserCommand': 'Update Administrator',
  'UpdateMyAdminPasswordCommand': 'Change My Password',

  // Authentication
  'AdminLoginCommand': 'Administrator Login',

  // Compliance Management
  'IssueWarningCommand': 'Issue Content Warning',
  'SuspendUserForComplianceCommand': 'Suspend User for Compliance',
  'RejectComplaintCommand': 'Reject Complaint',
  'ResolveComplaintCommand': 'Resolve Complaint',

  // Dispute Management
  'ApproveDisputeCommand': 'Approve Dispute Refund',
  'RejectDisputeCommand': 'Reject Dispute Request',
  'RequestMoreInformationCommand': 'Request More Dispute Info',

  // Ghost Verification
  'VerifyGhostCommand': 'Verify Ghost Application',
  'AllowPiLicenseUpdateCommand': 'Allow PI License Update',
  'AllowBondUpdateCommand': 'Allow Bond Update',

  // Mission Management
  'CancelMissionByAdminCommand': 'Cancel Mission (Admin)',

  // User Management
  'ActivateUserCommand': 'Activate User Account',
  'SuspendUserCommand': 'Suspend User Account',

  // Settings & Pricing
  'UpdateApplicationSettingCommand': 'Update Application Settings',
  'SetMissionPricingCommand': 'Set Mission Pricing',
};

export const getActionTypeDisplayName = (actionType: string): string => {
  return ACTION_TYPE_MAP[actionType] || actionType;
};
